module.exports = __webpack_public_path__ + "static/media/34taylorwelcome.bd36bf73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/34taylorwelcome.png
// module id = 127
// module chunks = 0